import { datadogLogs } from '@datadog/browser-logs';
import { useRefreshToken } from '@hooks/useRefreshToken';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useEffect } from 'react';
import { BaseApi } from '../../core/api';
import type { BaseUser } from '../../core/models/user';

export function useBaseUser() {
  const { mutate } = useRefreshToken();

  // eslint-disable-next-line @tanstack/query/no-rest-destructuring -- full query result re-exposed by design, matching sibling hooks.
  const { data, error, ...res } = useQuery({
    queryKey: ['imagery-base-user'],
    queryFn: async () => {
      const { data } = await BaseApi.get<BaseUser>('/accounts/me', {
        params: { include_extended: true },
      });

      return data;
    },
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });

  useEffect(() => {
    if (
      error instanceof AxiosError &&
      (error.response?.status === 401 || error.response?.status === 404)
    ) {
      mutate();
    } else if (error) {
      datadogLogs.logger.error('useBaseUser: Non-401 error occurred', {
        error: error instanceof Error ? error.message : String(error),
        errorType: error.constructor.name,
        status: error instanceof AxiosError ? error.response?.status : undefined,
        endpoint: '/accounts/me',
      });
    }
  }, [error, mutate]);

  return { user: data, ...res };
}
